import { useCuentaBancariaTesoreriaById } from "api/CuentaBancaria.hook"
import { useHistory } from "react-router-dom"

export const usePropuestasConciliacionHeader = ({
  cuentaId,
}: {
  cuentaId: string
}) => {
  const { cuentaBancariaById } = useCuentaBancariaTesoreriaById(cuentaId)
  const history = useHistory()

  return {
    cuentaBancariaById,
    handleBack: () => history.goBack(),
  }
}
